import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

const BlogPreviewSection = ({ posts }) => {
  const previewPosts = Array.isArray(posts) ? posts.slice(0, 3) : [];

  return (
    <section id="blog" data-testid="blog-preview-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
          <div>
            <p
              className="text-xs tracking-[0.3em] uppercase mb-4"
              style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
            >
              From Our Blog
            </p>
            <h2
              className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light"
              style={{ color: "var(--ll-text)" }}
            >
              Insights &{" "}
              <em className="italic" style={{ color: "var(--ll-text-secondary)" }}>
                Resources
              </em>
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-view-all"
            className="text-sm font-medium flex items-center gap-2 transition-all duration-300 hover:gap-3"
            style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
          >
            View All Posts <ArrowRight size={14} />
          </Link>
        </div>

        <BlogPreviewGrid posts={previewPosts} />
      </div>
    </section>
  );
};

const BlogPreviewGrid = ({ posts }) => {
  if (!posts || posts.length === 0) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="blog-preview-grid">
      {posts.map((post) => (
        <a
          key={post.id}
          href={`/blog/${post.id}`}
          data-testid={`blog-card-${post.id}`}
          className="group p-6 md:p-8 rounded-2xl transition-all duration-500 hover:-translate-y-1 block no-underline"
          style={{ background: "white", border: "1px solid var(--ll-border)", textDecoration: "none" }}
        >
          <div className="flex items-center gap-3 mb-4">
            <span
              className="text-xs tracking-[0.15em] uppercase px-3 py-1 rounded-full"
              style={{ background: "var(--ll-bg-secondary)", color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
            >
              {post.category}
            </span>
            <span className="flex items-center gap-1 text-xs" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
              <Clock size={12} />
              {post.read_time}
            </span>
          </div>
          <h3
            className="font-serif text-xl sm:text-2xl font-medium mb-3 transition-colors duration-300 group-hover:opacity-80"
            style={{ color: "var(--ll-text)" }}
          >
            {post.title}
          </h3>
          <p
            className="text-sm leading-relaxed mb-6"
            style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
          >
            {post.excerpt}
          </p>
          <div className="flex items-center justify-between">
            <p className="text-xs" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
              {new Date(post.date).toLocaleDateString("en-ZA", { year: "numeric", month: "long", day: "numeric" })}
            </p>
            <span
              className="text-sm font-medium flex items-center gap-1 transition-all duration-300 group-hover:gap-2"
              style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
            >
              Read <ArrowRight size={14} />
            </span>
          </div>
        </a>
      ))}
    </div>
  );
};

export default BlogPreviewSection;
